import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import type { RegistryApproval, RegistryApprovalStatus } from '../../api/registryApiTypes';
import RegistryApprovalCard from './RegistryApprovalCard';

export default function ApprovalList({
  approvals,
  loading,
  status,
  viewerId,
  viewerCanApprove,
  onDecide,
}: {
  approvals: RegistryApproval[];
  loading: boolean;
  status: RegistryApprovalStatus;
  viewerId: string;
  viewerCanApprove: boolean;
  onDecide: (item: RegistryApproval, approve: boolean) => void;
}) {
  if (loading) {
    return <Typography color="text.secondary">Loading…</Typography>;
  }
  if (approvals.length === 0) {
    return (
      <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {status === 'PENDING' ? 'Nothing waiting for approval.' : 'No decided requests.'}
        </Typography>
      </Paper>
    );
  }
  return (
    <Stack spacing={1.5}>
      {approvals.map((item) => (
        <RegistryApprovalCard
          key={item.externalId}
          approval={item}
          viewerId={viewerId}
          viewerCanApprove={viewerCanApprove}
          onDecide={(approve) => onDecide(item, approve)}
        />
      ))}
    </Stack>
  );
}
